import './styles/ui.css'
import { installDiagnostics } from './utils/diagnostics'
import { GameApp } from './engine/GameApp'
import { preloadReefAssets } from './game/world/reef-assets'
import { preloadReefMaterials } from './game/world/reef-materials'
import { preloadCharacterAssets } from './procedural/models'

// Dev/E2E only — keep the test harness off window in production builds.
if (import.meta.env.DEV) installDiagnostics()

const canvas = document.getElementById('game') as HTMLCanvasElement
const uiMount = document.getElementById('ui-root') as HTMLElement

// Build the first scene only when its authored assets are ready.
uiMount.textContent = 'Diving into BlueBob…'
Promise.all([
  document.fonts?.ready,
  preloadReefAssets(),
  preloadReefMaterials(),
  preloadCharacterAssets(),
]).then(() => {
  uiMount.textContent = ''
  new GameApp(canvas, uiMount)
}).catch(error => {
  console.error('BlueBob could not load its world', error)
  uiMount.textContent = 'The reef could not load. Please reload to try again.'
})
